// extracted by mini-css-extract-plugin
export default {"row":"customTable_row__53vRj","cell":"customTable_cell__G-bMB"};